/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 202309d9 (Tue Mar 17 17:42:15 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  AgreementWebhookRequestBody,
  AgreementWebhookRequestBodyToJSON,
  BackgroundCheckProcessingWebhookRequestBody,
  BackgroundCheckProcessingWebhookRequestBodyToJSON,
  SafetyTrainingWebhookRequestBody,
  SafetyTrainingWebhookRequestBodyToJSON,
  Success,
  SuccessFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface AuthorizeDotNetEventWebhookRequest
  extends runtime.BaseRequestParameters {
  body: { [key: string]: object | undefined }
}

export interface BackgroundCheckProcessingWebhookRequest
  extends runtime.BaseRequestParameters {
  body: BackgroundCheckProcessingWebhookRequestBody
}

export interface CompleteAgreementWebhookRequest
  extends runtime.BaseRequestParameters {
  body?: AgreementWebhookRequestBody
}

export interface ConfirmAdobeSignWebhookRequest
  extends runtime.BaseRequestParameters {}

export interface SafetyTrainingWebhookRequest
  extends runtime.BaseRequestParameters {
  body: SafetyTrainingWebhookRequestBody
}

/**
 * WebhooksApi - interface
 *
 * @export
 * @interface WebhooksApiInterface
 */
export interface WebhooksApiInterface {
  /**
   * Webhook trigger after a user submits their payment via Authorize.net using a credit card.     Updates the enrollments associated with the payment to ENROLLED and the payment status to PAID.     Also, emails the payee with a status notification received from ANet.
   * @summary Receives notifications from Authorize.net involving payment events
   * @param {{ [key: string]: object | undefined; }} requestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebhooksApiInterface
   */
  authorizeDotNetEventWebhookRaw(
    requestParameters: AuthorizeDotNetEventWebhookRequest
  ): Promise<runtime.ApiResponse<Success>>

  /**
   * Webhook trigger after a user submits their payment via Authorize.net using a credit card.     Updates the enrollments associated with the payment to ENROLLED and the payment status to PAID.     Also, emails the payee with a status notification received from ANet.
   * Receives notifications from Authorize.net involving payment events
   */
  authorizeDotNetEventWebhook(
    requestParameters: AuthorizeDotNetEventWebhookRequest
  ): Promise<Success>

  /**
   *
   * @summary Webhook is triggered by ministry safe when the Background Check is ready to be reviewed.      The background check details are retrieved from the Ministry Safe API,      the status, statusDate, and validDate are updated in the userScreening table,      and the Agreement is sent if it can be sent to the user.       https://developers.ministrysafe.com/#webhooks
   * @param {BackgroundCheckProcessingWebhookRequestBody} backgroundCheckProcessingWebhookRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebhooksApiInterface
   */
  backgroundCheckProcessingWebhookRaw(
    requestParameters: BackgroundCheckProcessingWebhookRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Webhook is triggered by ministry safe when the Background Check is ready to be reviewed.      The background check details are retrieved from the Ministry Safe API,      the status, statusDate, and validDate are updated in the userScreening table,      and the Agreement is sent if it can be sent to the user.       https://developers.ministrysafe.com/#webhooks
   */
  backgroundCheckProcessingWebhook(
    requestParameters: BackgroundCheckProcessingWebhookRequest
  ): Promise<void>

  /**
   * Webhook trigger after Completed agreement sign, this will create the actor for the user with new role and the contracted validity window and update the agreement status in the database.
   * @summary Complete an open agreement via webhook.
   * @param {AgreementWebhookRequestBody} [agreementWebhookRequestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebhooksApiInterface
   */
  completeAgreementWebhookRaw(
    requestParameters: CompleteAgreementWebhookRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Webhook trigger after Completed agreement sign, this will create the actor for the user with new role and the contracted validity window and update the agreement status in the database.
   * Complete an open agreement via webhook.
   */
  completeAgreementWebhook(
    requestParameters: CompleteAgreementWebhookRequest
  ): Promise<void>

  /**
   * This will be triggered when Creating a webhook to verify that the webhook url exist and the adobe client id exist for this application. It will also be triggered when we deactivate an webhook
   * @summary Validate the adobe sign webhook link, when activate or de-active a web hook
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebhooksApiInterface
   */
  confirmAdobeSignWebhookRaw(
    requestParameters: ConfirmAdobeSignWebhookRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * This will be triggered when Creating a webhook to verify that the webhook url exist and the adobe client id exist for this application. It will also be triggered when we deactivate an webhook
   * Validate the adobe sign webhook link, when activate or de-active a web hook
   */
  confirmAdobeSignWebhook(): Promise<void>

  /**
   *
   * @summary Webhook is triggered by Ministry Safe upon successful user completion of a Training.      The status, statusDate, and validDate fields are updated in the userScreening table based on the      information received from Ministry Safe, finally the Agreement is sent if      the background check is valid and completed without flag and training is approved.       https://developers.ministrysafe.com/#webhooks
   * @param {SafetyTrainingWebhookRequestBody} safetyTrainingWebhookRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WebhooksApiInterface
   */
  safetyTrainingWebhookRaw(
    requestParameters: SafetyTrainingWebhookRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Webhook is triggered by Ministry Safe upon successful user completion of a Training.      The status, statusDate, and validDate fields are updated in the userScreening table based on the      information received from Ministry Safe, finally the Agreement is sent if      the background check is valid and completed without flag and training is approved.       https://developers.ministrysafe.com/#webhooks
   */
  safetyTrainingWebhook(
    requestParameters: SafetyTrainingWebhookRequest
  ): Promise<void>
}

/**
 *
 */
export class WebhooksApi
  extends runtime.BaseAPI
  implements WebhooksApiInterface
{
  /**
   * Webhook trigger after a user submits their payment via Authorize.net using a credit card.     Updates the enrollments associated with the payment to ENROLLED and the payment status to PAID.     Also, emails the payee with a status notification received from ANet.
   * Receives notifications from Authorize.net involving payment events
   */
  async authorizeDotNetEventWebhookRaw(
    requestParameters: AuthorizeDotNetEventWebhookRequest
  ): Promise<runtime.ApiResponse<Success>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling authorizeDotNetEventWebhook.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/webhook/authorizeNet/AuthorizeDotNetEvent`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.body,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SuccessFromJSON(jsonValue)
    )
  }

  /**
   * Webhook trigger after a user submits their payment via Authorize.net using a credit card.     Updates the enrollments associated with the payment to ENROLLED and the payment status to PAID.     Also, emails the payee with a status notification received from ANet.
   * Receives notifications from Authorize.net involving payment events
   */
  async authorizeDotNetEventWebhook(
    requestParameters: AuthorizeDotNetEventWebhookRequest
  ): Promise<Success> {
    const response = await this.authorizeDotNetEventWebhookRaw(
      requestParameters
    )
    return await response.value()
  }

  /**
   * Webhook is triggered by ministry safe when the Background Check is ready to be reviewed.      The background check details are retrieved from the Ministry Safe API,      the status, statusDate, and validDate are updated in the userScreening table,      and the Agreement is sent if it can be sent to the user.       https://developers.ministrysafe.com/#webhooks
   */
  async backgroundCheckProcessingWebhookRaw(
    requestParameters: BackgroundCheckProcessingWebhookRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling backgroundCheckProcessingWebhook.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/webhook/ministrySafe/backgroundCheckProcessing`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: BackgroundCheckProcessingWebhookRequestBodyToJSON(
        requestParameters.body
      ),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Webhook is triggered by ministry safe when the Background Check is ready to be reviewed.      The background check details are retrieved from the Ministry Safe API,      the status, statusDate, and validDate are updated in the userScreening table,      and the Agreement is sent if it can be sent to the user.       https://developers.ministrysafe.com/#webhooks
   */
  async backgroundCheckProcessingWebhook(
    requestParameters: BackgroundCheckProcessingWebhookRequest
  ): Promise<void> {
    await this.backgroundCheckProcessingWebhookRaw(requestParameters)
  }

  /**
   * Webhook trigger after Completed agreement sign, this will create the actor for the user with new role and the contracted validity window and update the agreement status in the database.
   * Complete an open agreement via webhook.
   */
  async completeAgreementWebhookRaw(
    requestParameters: CompleteAgreementWebhookRequest
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/webhook/adobeSign/completeAgreement`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: AgreementWebhookRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Webhook trigger after Completed agreement sign, this will create the actor for the user with new role and the contracted validity window and update the agreement status in the database.
   * Complete an open agreement via webhook.
   */
  async completeAgreementWebhook(
    requestParameters?: CompleteAgreementWebhookRequest
  ): Promise<void> {
    await this.completeAgreementWebhookRaw(requestParameters || {})
  }

  /**
   * This will be triggered when Creating a webhook to verify that the webhook url exist and the adobe client id exist for this application. It will also be triggered when we deactivate an webhook
   * Validate the adobe sign webhook link, when activate or de-active a web hook
   */
  async confirmAdobeSignWebhookRaw(
    requestParameters: ConfirmAdobeSignWebhookRequest
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/webhook/adobeSign/completeAgreement`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * This will be triggered when Creating a webhook to verify that the webhook url exist and the adobe client id exist for this application. It will also be triggered when we deactivate an webhook
   * Validate the adobe sign webhook link, when activate or de-active a web hook
   */
  async confirmAdobeSignWebhook(
    requestParameters?: ConfirmAdobeSignWebhookRequest
  ): Promise<void> {
    await this.confirmAdobeSignWebhookRaw(requestParameters || {})
  }

  /**
   * Webhook is triggered by Ministry Safe upon successful user completion of a Training.      The status, statusDate, and validDate fields are updated in the userScreening table based on the      information received from Ministry Safe, finally the Agreement is sent if      the background check is valid and completed without flag and training is approved.       https://developers.ministrysafe.com/#webhooks
   */
  async safetyTrainingWebhookRaw(
    requestParameters: SafetyTrainingWebhookRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling safetyTrainingWebhook.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/webhook/ministrySafe/safetyTraining`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: SafetyTrainingWebhookRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Webhook is triggered by Ministry Safe upon successful user completion of a Training.      The status, statusDate, and validDate fields are updated in the userScreening table based on the      information received from Ministry Safe, finally the Agreement is sent if      the background check is valid and completed without flag and training is approved.       https://developers.ministrysafe.com/#webhooks
   */
  async safetyTrainingWebhook(
    requestParameters: SafetyTrainingWebhookRequest
  ): Promise<void> {
    await this.safetyTrainingWebhookRaw(requestParameters)
  }
}
